import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Layout,
  Menu,
  Dropdown,
  Icon,
  Drawer,
  Badge,
  Button,
  Modal,
  DatePicker,
  message,
} from "antd";

import axios from "services/axios";
import _get from "lodash/get";
import moment from "moment";
import { getCarList } from "store/actions/car";
import { authLogout } from "store/actions/auth";
import { biddingStatuses } from "store/actions/bidding";
import { getPricingAreaList } from "store/actions/area";
import logo from "assets/images/logo-min.png";
import Routes from "./routes";
import "./home-style.css";
import downloadExcel from "../../services/downloadExcel";

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
const { RangePicker } = DatePicker;

class Home extends Component {
  state = {
    collapsed: false,
    windowWidth: false,
    Bidding: {
      waitingOfferingStatus: 0,
      waitingNegotiationStatus: 0,
      dealConfirmationStatus: 0,
      waitingHandoverStatus: 0,
      documentApprovalStatus: 0,
      financeApprovalStatus: 0,
      finalStatus: 0,
    },
    visibleDownloadRequest: false,
    confirmLoadingDownloadRequest: false,
    rangeTimeRequestHarga: [],
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  collapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  onLogout = () => {
    this.props.authLogout();
    this.props.history.push("/");
  };

  visibleModalDownloadRequest() {
    this.setState({
      visibleDownloadRequest: !this.state.visibleDownloadRequest,
    });
  }

  async componentDidMount() {
    let width = window.innerWidth;
    await this.props.getPricingAreaList();
    await this.props.getCarList();
    let Bidding = await this.props.biddingStatuses();
    this.setState({
      ...this.state,
      Bidding,
    });

    if (width < 768) {
      this.setState({
        windowWidth: true,
      });
    }
  }

  async componentDidUpdate(prevProps) {
    const { Bidding } = this.props;
    if (
      prevProps.Bidding.waitingOfferingStatus !==
        Bidding.waitingOfferingStatus ||
      prevProps.Bidding.waitingNegotiationStatus !==
        Bidding.waitingNegotiationStatus ||
      prevProps.Bidding.dealConfirmationStatus !==
        Bidding.dealConfirmationStatus ||
      prevProps.Bidding.waitingHandoverStatus !==
        Bidding.waitingHandoverStatus ||
      prevProps.Bidding.documentApprovalStatus !==
        Bidding.documentApprovalStatus ||
      prevProps.Bidding.financeApprovalStatus !==
        Bidding.financeApprovalStatus ||
      prevProps.Bidding.finalStatus !== Bidding.finalStatus
    ) {
      this.setState({
        Bidding,
      });
    }
  }

  handleMenu = async (e) => {
    await localStorage.removeItem("EApprovalPage");
    if (e.key && !e.key.includes("price-list")) {
      switch (e.key) {
        case "1":
          this.props.history.push("/home");
          break;
        case "2":
          this.props.history.push("/home/calendar");
          break;
        case "appraisal":
          this.props.history.push("/home/appraisal");
          break;
        case "overview":
          this.props.history.push("/home/overview");
          break;

        case "offering":
          this.props.history.push("/home/internal-bidding/offering");
          break;
        case "negotiation":
          this.props.history.push("/home/internal-bidding/tnt");
          break;
        case "dealConfirmation":
          this.props.history.push("/home/internal-bidding/deal-confirmation");
          break;
        case "handover":
          this.props.history.push("/home/internal-bidding/handover");
          break;
        case "document":
          this.props.history.push("/home/internal-bidding/document-approval");
          break;
        case "finance":
          this.props.history.push("/home/internal-bidding/finance");
          break;
        case "final":
          this.props.history.push("/home/internal-bidding/final");
          break;
        case "pdi":
          this.props.history.push("/home/internal-bidding/pdi");
          break;

        case "trade-in-progress":
          this.props.history.push("/home/approval/trade-in-progress");
          break;
        case "trade-in-request-approved":
          this.props.history.push("/home/approval/trade-in-request-approved");
          break;
        case "trade-in-request-rejected":
          this.props.history.push("/home/approval/trade-in-request-rejected");
          break;
        case "trade-in-request-in-progress":
          this.props.history.push(
            "/home/approval/trade-in-request-in-progress"
          );
          break;
        case "trade-in-final-deal":
          this.props.history.push("/home/approval/trade-in-final-deal");
          break;
        case "trade-in-final-no-deal":
          this.props.history.push("/home/approval/trade-in-final-no-deal");
          break;

        case "new-car-in-progress":
          this.props.history.push("/home/approval/new-car-in-progress");
          break;
        case "new-car-in-request-approved":
          this.props.history.push("/home/approval/new-car-in-request-approved");
          break;
        case "new-car-in-request-rejected":
          this.props.history.push("/home/approval/new-car-in-request-rejected");
          break;
        case "new-car-in-request-in-progress":
          this.props.history.push(
            "/home/approval/new-car-in-request-in-progress"
          );
          break;
        case "new-car-final-deal":
          this.props.history.push("/home/approval/new-car-final-deal");
          break;
        case "new-car-final-no-deal":
          this.props.history.push("/home/approval/new-car-final-no-deal");
          break;

        case "e-approval-selling-system":
          this.props.history.push("/home/e-approval/selling-system");
          break;
        case "e-approval-search-license-plate":
          this.props.history.push("/home/e-approval/search-license-plate");
          break;
        case "e-approval-selling-system-boh":
          this.props.history.push("/home/e-approval/selling-system/boh");
          break;
        case "e-approval-selling-system-gm":
          this.props.history.push("/home/e-approval/selling-system/gm");
          break;

        case "gross-profit":
          this.props.history.push("/home/update/gross-profit");
          break;
        case "otr":
          this.props.history.push("/home/update/otr");
          break;

        case "price-list-jakarta":
          this.props.history.push("/home/price-list/jakarta");
          break;
        case "price-list-bogor":
          this.props.history.push("/home/price-list/bogor");
          break;
        case "price-list-bandung":
          this.props.history.push("/home/price-list/bandung");
          break;
        case "price-list-karawang":
          this.props.history.push("/home/price-list/karawang");
          break;
        case "price-list-surabaya":
          this.props.history.push("/home/price-list/surabaya");
          break;
        case "price-list-medan":
          this.props.history.push("/home/price-list/medan");
          break;

        case "banner-salesman":
          this.props.history.push("/home/banner/salesman");
          break;

        case "all-user":
          this.props.history.push("/home/all-user");
          break;
        case "sales-user":
          this.props.history.push("/home/sales-user");
          break;
        case "appraiser-user":
          this.props.history.push("/home/appraiser-user");
          break;
        case "branch-head-user":
          this.props.history.push("/home/branch-head-user");
          break;
        case "supervisor-user":
          this.props.history.push("/home/supervisor-user");
          break;
        case "pricing-user":
          this.props.history.push("/home/pricing-user");
          break;
        case "boh-user":
          this.props.history.push("/home/boh-user");
          break;
        case "tnt-user":
          this.props.history.push("/home/tnt-user");
          break;
        case "other-user":
          this.props.history.push("/home/other-user");
          break;
        case "ali-user":
          this.props.history.push("/home/ali-user");
          break;
        case "dispatcher-user":
          this.props.history.push("/home/dispatcher-user");
          break;
        case "abm-user":
          this.props.history.push("/home/abm-user");
          break;
        case "mobbi-supervisor-user":
          this.props.history.push("/home/mobbi-supervisor-user");
          break;
        case "general-manager-user":
          this.props.history.push("/home/general-manager-user");
          break;
        case "finance-user":
          this.props.history.push("/home/finance-user");
          break;

        case "customer-list":
          this.props.history.push("/home/customer-list");
          break;
        case "customer-car-list":
          this.props.history.push("/home/customer-car-list");
          break;
        case "car-booking-service-list":
          this.props.history.push("/home/car-booking-service-list");
          break;

        case "price-check-history-all":
          this.props.history.push("/home/price-check-history-all");
          break;
        case "price-check-history-sales":
          this.props.history.push("/home/price-check-history-sales");
          break;
        case "price-check-history-branch-head":
          this.props.history.push("/home/price-check-history-branch-head");
          break;
        case "price-check-history-supervisor":
          this.props.history.push("/home/price-check-history-supervisor");
          break;
        case "price-check-history-boh":
          this.props.history.push("/home/price-check-history-boh");
          break;

        case "mobbi-price-check-history-sales":
          this.props.history.push("/home/mobbi-price-check-history-sales");
          break;

        case "branch-list":
          this.props.history.push("/home/branch");
          break;

        case "pricing-area":
          this.props.history.push("/home/pricing-area");
          break;
        case "new-car-area":
          this.props.history.push("/home/new-car-area");
          break;
        case "branch-area":
          this.props.history.push("/home/branch-area");
          break;
        case "business-area":
          this.props.history.push("/home/business-area");
          break;
        case "mobbi-logs":
          this.props.history.push("/home/mobbi/logs");
          break;
        case "configurations":
          this.props.history.push("/home/configurations");
          break;

        case "price-list":
          break;

        default:
          console.error("INVALID MENU KEY");
          this.props.history.push("/home");
          break;
      }
    }
  };

  redirectPriceListAreaMenu(area) {
    this.props.history.push(`/home/price-list/${area.toLowerCase()}`);
  }

  redirectMobbiPriceListAreaMenu(area) {
    this.props.history.push(`/home/mobbi-price-list/${area.toLowerCase()}`);
  }

  async confirmationDownloadPriceRequest() {
    const { rangeTimeRequestHarga } = this.state;

    if (rangeTimeRequestHarga.length > 0) {
      axios
        .post(`/car-pricing-request/download`, {
          startDate: rangeTimeRequestHarga[0],
          endDate: rangeTimeRequestHarga[1],
        })
        .then((result) => {
          if (result.data.length > 0) {
            this.mapForDownloadCsvRequestHarga(result.data);
            this.visibleModalDownloadRequest();
          } else {
            message.error("Data Request Harga Kosong");
          }
        })
        .catch((err) => {
          message.error("Gagal mendapatkan data Request Harga");
        });
    }
  }

  mapForDownloadCsvRequestHarga = (data) => {
    let dataTable = data.map((d) => {
      return {
        Salesman: _get(d, "SalesProfile.User.name"),
        Cabang: _get(d, "SalesProfile.Branch.branch"),
        "Tipe Mobil": d.carSpec,
        Tahun: d.year,
        Sumber: d.sourceOfRequest,
        "Tanggal Request": moment(_get(d, "createdAt")).format(
          "DD/MM/YYYY HH:mm"
        ),
      };
    });
    downloadExcel(dataTable, "request_harga_mobil");
  };

  onChangeRangeRequestHarga(date, dateString) {
    this.setState({
      rangeTimeRequestHarga: dateString,
    });
  }

  render() {
    const { Auth } = this.props;
    console.log("auth", Auth);
    const accountMenu = (
      <Menu>
        <Menu.Item key="0">
          <Icon type="setting" />
          <span>Setting</span>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="1" onClick={this.onLogout}>
          <Icon type="logout" />
          <span>
            <a>Logout</a>
          </span>
        </Menu.Item>
      </Menu>
    );
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Modal
          visible={this.state.visibleDownloadRequest}
          title="Download Data Request Harga Mobil"
          onOk={() => this.confirmationDownloadPriceRequest()}
          onCancel={() => this.visibleModalDownloadRequest()}
          confirmLoading={this.state.confirmLoadingDownloadRequest}>
          <p>Pilih range waktu request harga mobil</p>
          <RangePicker
            format="YYYY-MM-DD HH:mm:ss"
            onChange={(date, dateString) =>
              this.onChangeRangeRequestHarga(date, dateString)
            }
          />
        </Modal>
        {this.state.windowWidth ? (
          <Drawer
            visible={!this.state.collapsed}
            placement="left"
            onClose={this.collapse}
            style={{
              padding: 0,
              margin: 0,
              backgroundColor: "transparent",
            }}
            closable={false}
            width={200}>
            <Sider
              collapsible
              collapsed={this.state.collapsed}
              onCollapse={this.onCollapse}
              collapsedWidth="0"
              trigger={null}
              breakpoint="md"
              style={{
                minHeight: "100vh",
                position: "relative",
                width: "100%",
                zIndex: 10,
              }}>
              <div
                style={{
                  background: "white",
                  margin: 16,
                  textAlign: "center",
                }}>
                <img
                  src={logo}
                  width={this.state.collapsed ? 30 : 80}
                  alt="img_logo"
                />
              </div>
              <Menu
                theme="dark"
                defaultSelectedKeys={
                  [
                    "SUPER_ADMIN",
                    "APPRAISAL_ADMIN",
                    "GP_ADMIN",
                    "DISPATCHER",
                  ].includes(Auth.user.role)
                    ? ["1"]
                    : ["appraisal"]
                }
                mode="inline"
                onClick={this.handleMenu}>
                {[
                  "SUPER_ADMIN",
                  "APPRAISAL_ADMIN",
                  "GP_ADMIN",
                  "TNT",
                  "ALI",
                  "DISPATCHER",
                ].includes(Auth.user.role)
                  ? [
                      <Menu.Item key="1">
                        <Icon type="pie-chart" />
                        <span>Internal Dispatch</span>
                      </Menu.Item>,
                      <Menu.Item key="2">
                        <Icon type="calendar" />
                        <span>Calendar</span>
                      </Menu.Item>,
                    ]
                  : null}
                {[
                  "SUPER_ADMIN",
                  "BUYER",
                  "ACQUISITOR",
                  "PRICE_NEGOTIATOR",
                  "GP_ADMIN",
                  "BOH",
                  "TNT",
                  "DATA_ADMIN",
                ].includes(Auth.user.role)
                  ? [
                      <Menu.Item key="appraisal">
                        <Icon type="car" />
                        <span>Appraisal</span>
                        <Badge
                          count={this.props.Bidding.appraisals}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>,
                    ]
                  : null}
                {[].includes(Auth.user.role)
                  ? [
                      <SubMenu
                        key="internalBidding"
                        title={
                          <span>
                            <Icon type="pay-circle" />
                            <span>Internal Bidding</span>
                          </span>
                        }>
                        <Menu.Item key="offering">
                          Offering
                          <Badge
                            count={this.props.Bidding.waitingOfferingStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                        <Menu.Item key="negotiation">
                          TNT
                          <Badge
                            count={this.props.Bidding.waitingNegotiationStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                        <Menu.Item key="dealConfirmation">
                          Deal Confirmation
                          <Badge
                            count={this.props.Bidding.dealConfirmationStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                        <Menu.Item key="handover">
                          Handover
                          <Badge
                            count={this.props.Bidding.waitingHandoverStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                        <Menu.Item key="pdi">PDI</Menu.Item>
                        <Menu.Item key="document">
                          Document Approval
                          <Badge
                            count={this.props.Bidding.documentApprovalStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                        <Menu.Item key="finance">
                          Finance
                          <Badge
                            count={this.props.Bidding.financeApprovalStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                        <Menu.Item key="final">
                          Final
                          <Badge
                            count={this.props.Bidding.finalStatus}
                            style={{ marginLeft: 8 }}
                            overflowCount={9999}
                          />
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}
                {["SUPER_ADMIN", "APPRAISAL_ADMIN", "GP_ADMIN"].includes(
                  Auth.user.role
                )
                  ? [
                      <SubMenu
                        key="User"
                        title={
                          <span>
                            <Icon type="team" />
                            <span>User</span>
                          </span>
                        }>
                        <Menu.Item key="all-user">
                          <span>All</span>
                        </Menu.Item>
                        <Menu.Item key="sales-user">
                          <span>Salesman</span>
                        </Menu.Item>
                        <Menu.Item key="appraiser-user">
                          <span>Appraiser</span>
                        </Menu.Item>
                        <Menu.Item key="branch-head-user">
                          <span>Kepala Cabang</span>
                        </Menu.Item>
                        <Menu.Item key="supervisor-user">
                          <span>Supervisor</span>
                        </Menu.Item>
                        <Menu.Item key="mobbi-supervisor-user">
                          <span>Mobbi Supervisor</span>
                        </Menu.Item>
                        <Menu.Item key="pricing-user">
                          <span>Pricing</span>
                        </Menu.Item>
                        <Menu.Item key="boh-user">
                          <span>BOH</span>
                        </Menu.Item>
                        <Menu.Item key="tnt-user">
                          <span>TNT</span>
                        </Menu.Item>
                        <Menu.Item key="ali-user">
                          <span>ALI</span>
                        </Menu.Item>
                        <Menu.Item key="dispatcher-user">
                          <span>Dispatcher</span>
                        </Menu.Item>
                        <Menu.Item key="abm-user">
                          <span>ABM</span>
                        </Menu.Item>
                        <Menu.Item key="general-manager-user">
                          <span>General Manager</span>
                        </Menu.Item>
                        <Menu.Item key="finance-user">
                          <span>Finance</span>
                        </Menu.Item>
                        {/* <Menu.Item key="other-user">

                          <span>Other</span>
                        </Menu.Item> */}
                      </SubMenu>,
                      <Menu.Item key="overview">
                        <Icon type="bar-chart" />
                        <span>Overview</span>
                      </Menu.Item>,
                    ]
                  : null}
                {["DOCUMENT_ADMIN"].includes(Auth.user.role)
                  ? [
                      <Menu.Item key="document">
                        Document Approval
                        <Badge
                          count={this.props.Bidding.documentApprovalStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>,
                    ]
                  : null}
                {["FINANCE_ADMIN"].includes(Auth.user.role)
                  ? [
                      <Menu.Item key="finance">
                        Finance
                        <Badge
                          count={this.props.Bidding.financeApprovalStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>,
                    ]
                  : null}
                {["GP_ADMIN", "SUPER_ADMIN", "PRICING", "FINANCE"].includes(
                  Auth.user.role
                )
                  ? [
                      <SubMenu
                        key="Update"
                        title={
                          <span>
                            <Icon type="money-collect" />
                            <span>Update</span>
                          </span>
                        }>
                        {/* <Menu.Item key="gross-profit">

                          <span>GrossProfit</span>
                        </Menu.Item> */}
                        <Menu.Item key="otr">
                          <span>OTR</span>
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}
                {["GP_ADMIN", "SUPER_ADMIN", "PRICING", "FINANCE"].includes(
                  Auth.user.role
                )
                  ? [
                      <SubMenu
                        key="PriceList"
                        title={
                          <span>
                            <Icon type="pay-circle" />
                            <span>Harga Beli/Jual</span>
                          </span>
                        }>
                        {this.props.Area &&
                          this.props.Area.pricingAreas &&
                          this.props.Area.pricingAreas.map((v, idx) => (
                            <Menu.Item
                              key={`price-list-${idx}`}
                              onClick={() =>
                                this.redirectPriceListAreaMenu(v.name)
                              }>
                              <span>{v.name}</span>
                            </Menu.Item>
                          ))}
                      </SubMenu>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN", "BOH", "DATA_ADMIN"].includes(
                  Auth.user.role
                )
                  ? [
                      <SubMenu
                        key="Cek Harga"
                        title={
                          <span>
                            <Icon type="reconciliation" />
                            <span>Cek Harga</span>
                          </span>
                        }>
                        <Menu.Item key="price-check-history-all">
                          <span>All</span>
                        </Menu.Item>
                        <Menu.Item key="price-check-history-sales">
                          <span>Salesman</span>
                        </Menu.Item>
                        <Menu.Item key="price-check-history-branch-head">
                          <span>Kepala Cabang</span>
                        </Menu.Item>
                        <Menu.Item key="price-check-history-supervisor">
                          <span>Supervisor</span>
                        </Menu.Item>
                        <Menu.Item key="price-check-history-boh">
                          <span>BOH</span>
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN", "PRICING", "FINANCE"].includes(
                  Auth.user.role
                )
                  ? [
                      <SubMenu
                        key="MobbiPriceList"
                        title={
                          <span>
                            <Icon type="pay-circle" />
                            <span>Mobbi Harga Beli/Jual</span>
                          </span>
                        }>
                        {this.props.Area &&
                          this.props.Area.pricingAreas &&
                          this.props.Area.pricingAreas.map((v, idx) => (
                            <Menu.Item
                              key={`mobbi-price-list-${idx}`}
                              onClick={() =>
                                this.redirectMobbiPriceListAreaMenu(v.name)
                              }>
                              <span>{v.name}</span>
                            </Menu.Item>
                          ))}
                      </SubMenu>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN", "BOH", "DATA_ADMIN"].includes(
                  Auth.user.role
                )
                  ? [
                      <SubMenu
                        key="Mobbi Cek Harga"
                        title={
                          <span>
                            <Icon type="reconciliation" />
                            <span>Mobbi Cek Harga</span>
                          </span>
                        }>
                        <Menu.Item key="mobbi-price-check-history-sales">
                          <span>Salesman</span>
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                  ? [
                      <SubMenu
                        key="Banner"
                        title={
                          <span>
                            <Icon type="cloud-download" />
                            <span>Banner</span>
                          </span>
                        }>
                        <Menu.Item key="banner-salesman">
                          <span>Salesman</span>
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                  ? [
                      <SubMenu
                        key="B2C"
                        title={
                          <span>
                            <Icon type="car" />
                            <span>B2C</span>
                          </span>
                        }>
                        <Menu.Item key="customer-list">
                          <span>Customer</span>
                        </Menu.Item>

                        <Menu.Item key="customer-car-list">
                          <span>Customer Car</span>
                        </Menu.Item>

                        <Menu.Item key="car-booking-service-list">
                          <span>Car Booking Service</span>
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}
                {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                  ? [
                      <Menu.Item key="branch-list">
                        <Icon type="shop" />
                        <span>Branch</span>
                      </Menu.Item>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                  ? [
                      <SubMenu
                        key="Area"
                        title={
                          <span>
                            <Icon type="cloud-download" />
                            <span>Area</span>
                          </span>
                        }>
                        <Menu.Item key="pricing-area">
                          <span>Pricing Area</span>
                        </Menu.Item>
                        <Menu.Item key="new-car-area">
                          <span>New Car Area</span>
                        </Menu.Item>
                        <Menu.Item key="branch-area">
                          <span>Branch Area</span>
                        </Menu.Item>
                        <Menu.Item key="business-area">
                          <span>Business Area</span>
                        </Menu.Item>
                      </SubMenu>,
                    ]
                  : null}

                {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                  ? [
                      <Menu.Item key="mobbi-logs">
                        <Icon type="shop" />
                        <span>Mobbi Logs</span>
                      </Menu.Item>,
                    ]
                  : null}
              </Menu>
            </Sider>
          </Drawer>
        ) : (
          <Sider
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
            collapsedWidth="0"
            trigger={null}
            breakpoint="md">
            <div
              style={{
                background: "white",
                margin: 16,
                textAlign: "center",
              }}>
              <img
                src={logo}
                width={this.state.collapsed ? 30 : 80}
                alt="img_logo"
              />
            </div>
            <Menu
              theme="dark"
              defaultSelectedKeys={
                [
                  "SUPER_ADMIN",
                  "APPRAISAL_ADMIN",
                  "GP_ADMIN",
                  "DISPATCHER",
                ].includes(Auth.user.role)
                  ? ["1"]
                  : ["appraisal"]
              }
              mode="inline"
              onClick={this.handleMenu}>
              {[
                "SUPER_ADMIN",
                "APPRAISAL_ADMIN",
                "GP_ADMIN",
                "TNT",
                "ALI",
                "DISPATCHER",
              ].includes(Auth.user.role)
                ? [
                    <Menu.Item key="1">
                      <Icon type="pie-chart" />
                      <span>Internal Dispatch</span>
                    </Menu.Item>,
                    <Menu.Item key="2">
                      <Icon type="calendar" />
                      <span>Calendar</span>
                    </Menu.Item>,
                  ]
                : null}
              {[
                "SUPER_ADMIN",
                "BUYER",
                "ACQUISITOR",
                "PRICE_NEGOTIATOR",
                "GP_ADMIN",
                "BOH",
                "TNT",
                "ALI",
                "DATA_ADMIN",
              ].includes(Auth.user.role)
                ? [
                    <Menu.Item key="appraisal">
                      <Icon type="car" />
                      <span>Appraisal</span>
                      <Badge
                        count={this.props.Bidding.appraisals}
                        style={{ marginLeft: 8 }}
                        overflowCount={9999}
                      />
                    </Menu.Item>,
                  ]
                : null}
              {[].includes(Auth.user.role)
                ? [
                    <SubMenu
                      key="internalBidding"
                      title={
                        <span>
                          <Icon type="pay-circle" />
                          <span>Internal Bidding</span>
                        </span>
                      }>
                      <Menu.Item key="offering">
                        Offering
                        <Badge
                          count={this.props.Bidding.waitingOfferingStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                      <Menu.Item key="negotiation">
                        TNT
                        <Badge
                          count={this.props.Bidding.waitingNegotiationStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                      <Menu.Item key="dealConfirmation">
                        Deal Confirmation
                        <Badge
                          count={this.props.Bidding.dealConfirmationStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                      <Menu.Item key="handover">
                        Handover
                        <Badge
                          count={this.props.Bidding.waitingHandoverStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                      <Menu.Item key="pdi">PDI</Menu.Item>
                      <Menu.Item key="document">
                        Document Approval
                        <Badge
                          count={this.props.Bidding.documentApprovalStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                      <Menu.Item key="finance">
                        Finance
                        <Badge
                          count={this.props.Bidding.financeApprovalStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                      <Menu.Item key="final">
                        Final
                        <Badge
                          count={this.props.Bidding.finalStatus}
                          style={{ marginLeft: 8 }}
                          overflowCount={9999}
                        />
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}
              {["SUPER_ADMIN", "APPRAISAL_ADMIN", "GP_ADMIN"].includes(
                Auth.user.role
              )
                ? [
                    <SubMenu
                      key="User"
                      title={
                        <span>
                          <Icon type="team" />
                          <span>User</span>
                        </span>
                      }>
                      <Menu.Item key="all-user">
                        <span>All</span>
                      </Menu.Item>
                      <Menu.Item key="sales-user">
                        <span>Salesman</span>
                      </Menu.Item>
                      <Menu.Item key="appraiser-user">
                        <span>Appraiser</span>
                      </Menu.Item>
                      <Menu.Item key="branch-head-user">
                        <span>Kepala Cabang</span>
                      </Menu.Item>
                      <Menu.Item key="supervisor-user">
                        <span>Supervisor</span>
                      </Menu.Item>
                      <Menu.Item key="mobbi-supervisor-user">
                        <span>Mobbi Supervisor</span>
                      </Menu.Item>
                      <Menu.Item key="pricing-user">
                        <span>Pricing</span>
                      </Menu.Item>
                      <Menu.Item key="boh-user">
                        <span>BOH</span>
                      </Menu.Item>
                      <Menu.Item key="tnt-user">
                        <span>TNT</span>
                      </Menu.Item>
                      <Menu.Item key="ali-user">
                        <span>ALI</span>
                      </Menu.Item>
                      <Menu.Item key="dispatcher-user">
                        <span>Dispatcher</span>
                      </Menu.Item>
                      <Menu.Item key="abm-user">
                        <span>ABM</span>
                      </Menu.Item>
                      <Menu.Item key="general-manager-user">
                        <span>General Manager</span>
                      </Menu.Item>
                      <Menu.Item key="finance-user">
                        <span>Finance</span>
                      </Menu.Item>
                      {/* <Menu.Item key="other-user">

                        <span>Other</span>
                      </Menu.Item> */}
                    </SubMenu>,
                    <Menu.Item key="overview">
                      <Icon type="bar-chart" />
                      <span>Overview</span>
                    </Menu.Item>,
                  ]
                : null}
              {["DOCUMENT_ADMIN"].includes(Auth.user.role)
                ? [
                    <Menu.Item key="document">
                      Document Approval
                      <Badge
                        count={this.props.Bidding.documentApprovalStatus}
                        style={{ marginLeft: 8 }}
                        overflowCount={9999}
                      />
                    </Menu.Item>,
                  ]
                : null}
              {["FINANCE_ADMIN"].includes(Auth.user.role)
                ? [
                    <Menu.Item key="finance">
                      Finance
                      <Badge
                        count={this.props.Bidding.financeApprovalStatus}
                        style={{ marginLeft: 8 }}
                        overflowCount={9999}
                      />
                    </Menu.Item>,
                  ]
                : null}
              {[
                "SUPER_ADMIN",
                "GP_ADMIN",
                "BOH",
                "FINANCE",
                "SALES_USER",
                "GENERAL_MANAGER",
              ].includes(Auth.user.role)
                ? [
                    <SubMenu
                      key="Approval"
                      title={
                        <span>
                          <Icon type="reconciliation" />
                          <span>Approval</span>
                        </span>
                      }>
                      {["SUPER_ADMIN", "GP_ADMIN", "BOH", "FINANCE"].includes(
                        Auth.user.role
                      ) ? (
                        <SubMenu
                          key="Trade-In"
                          title={
                            <span>
                              <Icon type="reconciliation" />
                              <span>Trade-In</span>
                            </span>
                          }>
                          <Menu.Item key="trade-in-progress">
                            <span>New Approval</span>
                          </Menu.Item>

                          <Menu.Item key="trade-in-request-in-progress">
                            <span>Request In Progress</span>
                          </Menu.Item>

                          <Menu.Item key="trade-in-request-approved">
                            <span>Request Approved</span>
                          </Menu.Item>

                          <Menu.Item key="trade-in-request-rejected">
                            <span>Request Rejected</span>
                          </Menu.Item>

                          <Menu.Item key="trade-in-final-deal">
                            <span>Deal</span>
                          </Menu.Item>

                          <Menu.Item key="trade-in-final-no-deal">
                            <span>No Deal</span>
                          </Menu.Item>
                        </SubMenu>
                      ) : null}

                      {["SUPER_ADMIN", "GP_ADMIN", "BOH", "FINANCE"].includes(
                        Auth.user.role
                      ) ? (
                        <SubMenu
                          key="New Car"
                          title={
                            <span>
                              <Icon type="reconciliation" />
                              <span>New Car</span>
                            </span>
                          }>
                          <Menu.Item key="new-car-in-progress">
                            <span>New Approval</span>
                          </Menu.Item>

                          <Menu.Item key="new-car-in-request-in-progress">
                            <span>Request In Progress</span>
                          </Menu.Item>

                          <Menu.Item key="new-car-in-request-approved">
                            <span>Request Approved</span>
                          </Menu.Item>

                          <Menu.Item key="new-car-in-request-rejected">
                            <span>Request Rejected</span>
                          </Menu.Item>

                          <Menu.Item key="new-car-final-deal">
                            <span>Deal</span>
                          </Menu.Item>

                          <Menu.Item key="new-car-final-no-deal">
                            <span>No Deal</span>
                          </Menu.Item>
                        </SubMenu>
                      ) : null}

                      <Menu.Item key="e-approval-selling-system">
                        <Icon type="reconciliation" />
                        <span>Selling System</span>
                      </Menu.Item>

                      {["BOH", "GENERAL_MANAGER", "FINANCE"].includes(
                        Auth.user.role
                      ) ? (
                        <Menu.Item key="e-approval-search-license-plate">
                          <Icon type="search" />
                          <span>Pencarian Nopol</span>
                        </Menu.Item>
                      ) : null}
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN", "PRICING", "FINANCE"].includes(
                Auth.user.role
              )
                ? [
                    <SubMenu
                      key="Update"
                      title={
                        <span>
                          <Icon type="money-collect" />
                          <span>Update</span>
                        </span>
                      }>
                      {/* <Menu.Item key="gross-profit">
                        <span>GrossProfit</span>
                      </Menu.Item> */}

                      <Menu.Item key="otr">
                        <span>OTR</span>
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN", "PRICING", "FINANCE"].includes(
                Auth.user.role
              )
                ? [
                    <SubMenu
                      key="PriceList"
                      title={
                        <span>
                          <Icon type="pay-circle" />
                          <span>Harga Beli / Jual</span>
                        </span>
                      }>
                      {this.props.Area &&
                        this.props.Area.pricingAreas &&
                        this.props.Area.pricingAreas.map((v, idx) => (
                          <Menu.Item
                            key={`price-list-${idx}`}
                            onClick={() =>
                              this.redirectPriceListAreaMenu(v.name)
                            }>
                            <span>{v.name}</span>
                          </Menu.Item>
                        ))}
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN", "BOH", "DATA_ADMIN"].includes(
                Auth.user.role
              )
                ? [
                    <SubMenu
                      key="Cek Harga"
                      title={
                        <span>
                          <Icon type="reconciliation" />
                          <span>Cek Harga</span>
                        </span>
                      }>
                      <Menu.Item key="price-check-history-all">
                        <span>All</span>
                      </Menu.Item>
                      <Menu.Item key="price-check-history-sales">
                        <span>Salesman</span>
                      </Menu.Item>
                      <Menu.Item key="price-check-history-branch-head">
                        <span>Kepala Cabang</span>
                      </Menu.Item>
                      <Menu.Item key="price-check-history-supervisor">
                        <span>Supervisor</span>
                      </Menu.Item>
                      <Menu.Item key="price-check-history-boh">
                        <span>BOH</span>
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN", "PRICING", "FINANCE"].includes(
                Auth.user.role
              )
                ? [
                    <SubMenu
                      key="MobbiPriceList"
                      title={
                        <span>
                          <Icon type="pay-circle" />
                          <span>Mobbi Harga Beli/Jual</span>
                        </span>
                      }>
                      {this.props.Area &&
                        this.props.Area.pricingAreas &&
                        this.props.Area.pricingAreas.map((v, idx) => (
                          <Menu.Item
                            key={`mobbi-price-list-${idx}`}
                            onClick={() =>
                              this.redirectMobbiPriceListAreaMenu(v.name)
                            }>
                            <span>{v.name}</span>
                          </Menu.Item>
                        ))}
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN", "BOH", "DATA_ADMIN"].includes(
                Auth.user.role
              )
                ? [
                    <SubMenu
                      key="Mobbi Cek Harga"
                      title={
                        <span>
                          <Icon type="reconciliation" />
                          <span>Mobbi Cek Harga</span>
                        </span>
                      }>
                      <Menu.Item key="mobbi-price-check-history-sales">
                        <span>Salesman</span>
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                ? [
                    <SubMenu
                      key="Banner"
                      title={
                        <span>
                          <Icon type="cloud-download" />
                          <span>Banner</span>
                        </span>
                      }>
                      <Menu.Item key="banner-salesman">
                        <span>Salesman</span>
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                ? [
                    <SubMenu
                      key="B2C"
                      title={
                        <span>
                          <Icon type="car" />
                          <span>B2C</span>
                        </span>
                      }>
                      <Menu.Item key="customer-list">
                        <span>Customer</span>
                      </Menu.Item>

                      <Menu.Item key="customer-car-list">
                        <span>Customer Car</span>
                      </Menu.Item>

                      <Menu.Item key="car-booking-service-list">
                        <span>Car Booking Service</span>
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                ? [
                    <Menu.Item key="branch-list">
                      <Icon type="shop" />
                      <span>Branch</span>
                    </Menu.Item>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                ? [
                    <SubMenu
                      key="Area"
                      title={
                        <span>
                          <Icon type="cloud-download" />
                          <span>Area</span>
                        </span>
                      }>
                      <Menu.Item key="pricing-area">
                        <span>Pricing Area</span>
                      </Menu.Item>
                      <Menu.Item key="new-car-area">
                        <span>New Car Area</span>
                      </Menu.Item>
                      <Menu.Item key="branch-area">
                        <span>Branch Area</span>
                      </Menu.Item>
                      <Menu.Item key="business-area">
                        <span>Business Area</span>
                      </Menu.Item>
                    </SubMenu>,
                  ]
                : null}

              {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                ? [
                    <Menu.Item key="mobbi-logs">
                      <Icon type="shop" />
                      <span>Mobbi Logs</span>
                    </Menu.Item>,
                  ]
                : null}

              {/* {["GP_ADMIN", "SUPER_ADMIN"].includes(Auth.user.role)
                ? [
                    <Menu.Item key="configurations">
                      <Icon type="shop" />
                      <span>Configuration</span>
                    </Menu.Item>,
                  ]
                : null} */}
            </Menu>
          </Sider>
        )}

        <Layout>
          <Header style={{ background: "#fff", padding: 0 }}>
            <div className="headercontainer">
              <Icon
                className="trigger"
                type={this.state.collapsed ? "menu-unfold" : "menu-fold"}
                onClick={this.collapse}
              />
              <div
                style={{
                  paddingLeft: 24,
                  paddingRight: 24,
                  marginRight: 16,
                  textAlign: "right",
                }}>
                <Button
                  type="primary"
                  style={{ marginRight: 20 }}
                  onClick={() => this.visibleModalDownloadRequest()}>
                  Download Request Harga
                </Button>

                <Dropdown overlay={accountMenu} trigger={["click"]}>
                  <a className="ant-dropdown-link">
                    <Icon type="user" /> {Auth.user.email} <Icon type="down" />
                  </a>
                </Dropdown>
              </div>
            </div>
          </Header>
          <Content style={{ margin: "0 16px" }}>
            <Routes />
          </Content>
          <Footer style={{ textAlign: "center" }}>Toyota Trust ©2018</Footer>
        </Layout>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { authLogout, biddingStatuses, getCarList, getPricingAreaList },
    dispatch
  );

const mapStateToProps = ({ Auth, Bidding, Area }) => ({ Auth, Bidding, Area });

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/containers/Dashboard/Dashboard.js